import { Option } from "../engine/models/models";

export class InspirationRoomOptionModel {
  absoluteX: number;
  absoluteY: number;
  displayName: string;
  description: string;
  price: number;
  externalId: number;
  id: number;
  isChildOption: boolean;
  subLabel: string;
  labelDirection: number;
  createdById: string;
  globalOptions: Option;
  optionId: number;
  roomId: number;
  styleSelections: InspirationRoomOptionStyle[]
}

export class InspirationRoomOptionStyle {
  id: number;
  styleSelection: string;
  styleSelectionId: number;
  style: string;
  styleId: number;
  optionId: number;
  inspirationRoomOptionId: number;
  displayName: string;
  inActive: boolean = false;
}


